import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import Router from "./Routes/Router";

import "./index.css";
import "./premiaciones.css";
import "./slider.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { GlobalProvider } from "./Context/globalContext";

import store from "./Firebase/store";

ReactDOM.render(
  <Provider store={store}>
    <GlobalProvider>
      <Router />
    </GlobalProvider>
  </Provider>,
  document.getElementById("root")
);
